// import React from "react";
// import Navbar from "./components/navbar/Navbar";
// import Section1 from "./components/section1/Section1";
// import "./App.css";
// import DashboardLock from "./components/dashboards/DashboardSection";
// import Section2 from "./components/section2/Section2";
// import Section3 from "./components/section3/section3";
// import Section4 from "./components/section4/section4";
// import Section5 from "./components/section5/section5";
// import Section6 from "./components/section6/section6";
// import Section7 from "./components/section7/section7";
// import Section8 from "./components/section8/section8";
// import Section10 from "./components/section10/section10";
// import Section9 from "./components/section9/section9";
// import Footer from "./components/footer/Footer";
// import { ThreeDCardDemo } from "./components/AceternityUI/3D-cardEffect/3d-cardComponent";
// import BackgroundGradientDemo from "./components/AceternityUI/3D-cardEffect/backgroundgradient";
// import WavyBackground from "./components/AceternityUI/3D-cardEffect/WavyBackground";
// import AboutUs from "./components/AboutUs/AboutUs";
// // import { CardSpotlight } from "./styles/cardSpotlight"

// const App: React.FC = () => {
//   return (

//     <div className="app-container">
//       {/* <CardSpotlight children={undefined} /> */}
//       <div
//         className="top-bubble"
//         style={{ backgroundImage: `url(/assets/top-bubble.png)` }}
//       />
//       <div
//         className="bubblesection1"
//         style={{ backgroundImage: `url(/assets/bubblemiddle.png)` }}
//       />
//       <div
//         className="lower-bubble"
//         style={{ backgroundImage: `url(/assets/bubble3.png)` }}
//       />

//       <Navbar />

//       <div style={{ marginTop: "100px" }}>
//         <Section1 />
//       </div>
//       <div style={{ marginTop: "-240px" }}>
//         <DashboardLock />
//       </div>
//       <div style={{ marginTop: "240px" }}>
//         <Section2 />
//       </div>
//       <div style={{ marginTop: "60px" }}>
//         <Section3 />
//       </div>
//       <div style={{ marginTop: "240px" }}>
//         <Section4 />
//       </div>

//       <div style={{ marginTop: "100px" }}>
//         <Section5 />
//       </div>
//       <div style={{ marginTop: "240px" }}>
//         <Section6 />
//       </div>
//       <div style={{ marginTop: "240px" }}>
//         <Section7 />
//       </div>
//       <div style={{ marginTop: "-300px" }}>
//         <Section8 />
//       </div>
//       <div style={{ marginTop: "-200px" }}>
//         <Section9 />
//       </div>
//       <div style={{ marginTop: "200px" }}>
//         <Section10 />
//       </div>
//       <div style={{ marginTop: "400px" }}>
//         <Footer />
//       </div>
//       {/* <ThreeDCardDemo/> */}
//       {/* <WavyBackground/> */}
//       <AboutUs/>
//     </div>
//   );
// };

// export default App;
import React, { useRef, useState } from "react";
import Navbar from "./components/navbar/Navbar";
import Section1 from "./components/section1/Section1";
import "./App.css";
// import DashboardLock from "./components/dashboards/DashboardSection";
import Section2 from "./components/section2/Section2";
import Section3 from "./components/section3/section3";
import Section4 from "./components/section4/section4";
import Section5 from "./components/section5/section5";
import Section6 from "./components/section6/section6";
import Section7 from "./components/section7/section7";
import Section8 from "./components/section8/section8";
// import Section9 from "./components/section9/section9";
import Section10 from "./components/section10/section10";
import Footer from "./components/footer/Footer";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import ContactSales from "./components/Contactsales/contactsales";
import AboutUs from "./components/AboutUs/AboutUs";
// import CardScroll from "./components/AceternityUI/CardScroll";
import { ToastContainer } from "react-toastify";
import AnimatedCard from "./components/AceternityUI/3D-cardEffect/AnimatedCard";

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
  const location = useLocation(); // Now safely inside Router
  const section6Ref = useRef<HTMLDivElement | null>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  gsap.registerPlugin(ScrollTrigger);

  const handleScrollToSection6 = () => {
    // Typecast each trigger properly
    ScrollTrigger.getAll().forEach((trigger) => {
      (trigger as ScrollTrigger).disable();
    });

    section6Ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  // Dynamically set background based on the route
  const getBackgroundStyle = () => {
    switch (location.pathname) {
      case "/about-us":
        return {
          background: "linear-gradient(to right, #5f6e91 30%, #38174b 70%)",
        };
      case "/contact-sales":
        return {
          background: "linear-gradient(to right, #1d9f9f 30%, #38174b 70%)",
        };
      case "/":
        return {
          background: "linear-gradient(to right, #1d9f9f 30%, #38174b 70%)",
        };
    }
  };

  return (
    <div className="app-container" style={getBackgroundStyle()}>
      <Navbar onScrollToSection6={handleScrollToSection6} />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <div
                className="top-bubble"
                style={{ backgroundImage: `url(/assets/topBubble.svg)` }}
              />
              <div
                className="bubblesection1"
                style={{ backgroundImage: `url(/assets/bubble2.svg)` }}
              />
              {/* <div className="lower-bubble" style={{ backgroundImage: `url(/assets/bubble3.png)` }} /> */}
              <div>
                <Section1 />
              </div>
              <div >
                <AnimatedCard />
              </div>
              {/* <div style={{ marginTop: "-210px" }}><DashboardLock /></div> */}

              <div id="section2">
                <Section2 />
              </div>
              <div>
                <Section3 />
              </div>
              <div>
                <Section4 />
              </div>
              {/* 
              {isMobile && (
                <div>
                  <Section5 />
                </div>
              )} */}
              <>
                {/* Sections go here */}
                {!isMobile && (
                  <div>
                    <Section5 />
                  </div>
                )}
                {/* Other content */}
              </>

              <div id="section6" ref={section6Ref}>
                <Section6 />
              </div>
              <div>
                <Section7 />
              </div>
              <div>
                <Section8 />
              </div>

              {/* <div style={{ marginTop: "-400px" }}><Section9 /></div> */}
              <div>
                <Section10 />
              </div>
              <div id="footer-section" style={{ marginTop: "100px" }}>
                <Footer />
              </div>
            </>
          }
        />

        <Route
          path="/contact-sales"
          element={
            <>
              <div
                className="top-bubble"
                style={{ backgroundImage: `url(/assets/top-bubble.png)` }}
              />
              <div
                className="bubblesection1"
                style={{ backgroundImage: `url(/assets/bubble-2.png)` }}
              />
              <div
                className="lower-bubble"
                style={{ backgroundImage: `url(/assets/bubble3.png)` }}
              />
              <div>
                <ContactSales />
              </div>
              <div id="footer-section" style={{ marginTop: "200px" }}>
                <Footer />
              </div>
              <ToastContainer />
            </>
          }
        />

        <Route
          path="/about-us"
          element={
            <>
              <div
                className="top-bubble"
                style={{ backgroundImage: `url(/assets/top-bubble.png)` }}
              />
              <div
                className="bubblesection1"
                style={{ backgroundImage: `url(/assets/bubble-2.png)` }}
              />
              <div
                className="lower-bubble"
                style={{ backgroundImage: `url(/assets/bubble3.png)` }}
              />
              <div>
                <AboutUs />
              </div>
            </>
          }
        />
      </Routes>
    </div>
  );
};

export default App;
